import React from 'react';

const TMDB_LOGO_BASE = 'https://image.tmdb.org/t/p/w92';

const WhereToWatch = ({ region, regionLabel, providers, isGlobal }) => {
  return (
    <section className="block" data-testid="show-where-to-watch">
      <h2 className="block-title">Where to watch</h2>
      {isGlobal ? (
        <p className="block-note">
          Pick a specific region (🇳🇿/🇦🇺/🇺🇸/🇬🇧/🇨🇦) up top to see streaming options near you.
        </p>
      ) : providers && providers.length > 0 ? (
        <div className="providers">
          {providers.map((p) => (
            <span key={p.provider_id} className="provider" title={p.name} data-testid={`provider-${p.provider_id}`}>
              {p.logo_path ? (
                <img
                  src={`${TMDB_LOGO_BASE}${p.logo_path}`}
                  alt={p.name}
                  width="40"
                  height="40"
                  loading="lazy"
                />
              ) : null}
              <span className="provider-name">{p.name}</span>
            </span>
          ))}
        </div>
      ) : (
        <p className="block-note">
          No streaming providers found for {regionLabel}. Try TMDB directly for
          the latest availability.
        </p>
      )}

      <style jsx>{`
        .block {
          margin: 2rem 0;
        }
        .block-title {
          color: #E62F88;
          font-size: 0.72rem;
          font-weight: 800;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          margin: 0 0 1rem;
        }
        .block-note {
          color: #a1a1aa;
          font-size: 0.9rem;
          line-height: 1.55;
          margin: 0;
        }
        .providers {
          display: flex;
          gap: 0.65rem;
          flex-wrap: wrap;
        }
        .provider {
          display: inline-flex;
          align-items: center;
          gap: 0.55rem;
          background: #161616;
          border: 1px solid #232323;
          border-radius: 10px;
          padding: 0.45rem 0.85rem 0.45rem 0.45rem;
          transition: border-color 0.18s, transform 0.18s;
        }
        .provider:hover {
          border-color: rgba(230, 47, 136, 0.4);
          transform: translateY(-1px);
        }
        .provider img {
          display: block;
          border-radius: 6px;
        }
        .provider-name {
          color: #fff;
          font-size: 0.9rem;
          font-weight: 600;
        }
      `}</style>
    </section>
  );
};

export default WhereToWatch;
